import { render, staticRenderFns } from "./SurveyHeader.vue?vue&type=template&id=0c0243c4&"
import script from "./SurveyHeader.vue?vue&type=script&lang=ts&"
export * from "./SurveyHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyHeader.vue?vue&type=style&index=0&id=0c0243c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports